import { useEffect } from 'react';
import { useAuthState } from '../core/context/auth';
import { useSetSignedImageCookie } from '../modules/account/api';

const SignedCookieFetcher: React.FC = ({ children }) => {
  const { accessToken } = useAuthState();
  const setSignedImagedCookie = useSetSignedImageCookie();
  useEffect(() => {
    if (accessToken) {
      document.addEventListener('visibilitychange', () => {
        if (document.visibilityState === 'visible') {
          setSignedImagedCookie.mutate();
        }
      });
    }
    return () => {
      document.removeEventListener('visibilitychange', () => {
        if (document.visibilityState === 'visible') {
          setSignedImagedCookie.mutate();
        }
      });
    };
  }, [setSignedImagedCookie, accessToken]);

  return <>{children}</>;
};

export default SignedCookieFetcher;
